import { FC, memo, useMemo } from 'react';

import { MiddleOfficeConfigProviderProps } from './types/MiddleOfficeConfigProviderProps';
import { MiddleOfficeConfigClassDEPRECATED } from './MiddleOfficeConfigClassDEPRECATED';
import { MiddleOfficeConfigContext } from './MiddleOfficeConfigContext';

const MiddleOfficeConfigProviderComponent: FC<
  MiddleOfficeConfigProviderProps
> = ({ children, value }) => {
  const middleOfficeConfigValue = useMemo(
    () => new MiddleOfficeConfigClassDEPRECATED(value),
    [value],
  );
  return (
    <MiddleOfficeConfigContext.Provider value={middleOfficeConfigValue}>
      {children}
    </MiddleOfficeConfigContext.Provider>
  );
};

export const MiddleOfficeConfigProvider = memo(
  MiddleOfficeConfigProviderComponent,
);
